/**
 * Canonical parent-layout event names for GTM triggers / GA4 custom events.
 * Keep names snake_case; map them 1:1 in GTM Custom Event triggers.
 */
export const ParentAnalyticsEvents = {
  PAGE_VIEW: 'parent_page_view',
  CLICK_TAB: 'click_tab',
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  SIGNOUT: 'signout',
  ADD_KID: 'add_kid',
  VERIFY_IDENTITY: 'verify_identity',
  OPEN_AI_ASSISTANT: 'open_ai_assistant',
  UPGRADE_PLAN: 'upgrade_plan',
  APPLY_DUTY: 'apply_duty',
} as const;

export type ParentAnalyticsEvent =
  (typeof ParentAnalyticsEvents)[keyof typeof ParentAnalyticsEvents];

/** Tab / destination names used with {@link ParentAnalyticsEvents.CLICK_TAB}. */
export const ParentAnalyticsTabs = {
  DUTIES: 'duties',
  COURSES: 'courses',
  SETTINGS: 'settings',
  SUBSCRIPTIONS: 'subscriptions',
  GENERAL: 'general',
  HOME: 'home',
  PROFILE: 'profile',
  IDENTITY: 'identity',
  PATROL: 'patrol',
  AI_ASSISTANT: 'ai_assistant',
} as const;

export type ParentAnalyticsTab =
  (typeof ParentAnalyticsTabs)[keyof typeof ParentAnalyticsTabs];

export const PARENT_ANALYTICS_LAYOUT = 'parent' as const;

/** Maps parent SPA paths to a stable page_section for page_view events. */
export function resolveParentPageSection(url: string): string {
  const path = (url.split('?')[0] || '/').replace(/\/+$/, '') || '/';

  if (path === '/home' || path === '/home/welcome') {
    return ParentAnalyticsTabs.HOME;
  }
  if (path.startsWith('/home/assignments')) {
    return ParentAnalyticsTabs.DUTIES;
  }
  if (path.startsWith('/home/courses')) {
    return ParentAnalyticsTabs.COURSES;
  }
  if (path.startsWith('/profile')) {
    return ParentAnalyticsTabs.PROFILE;
  }
  if (path.startsWith('/identity')) {
    return ParentAnalyticsTabs.IDENTITY;
  }
  if (path.startsWith('/patrol')) {
    return ParentAnalyticsTabs.PATROL;
  }
  if (path.startsWith('/ai-assistant')) {
    return ParentAnalyticsTabs.AI_ASSISTANT;
  }
  if (path.startsWith('/auth')) {
    return 'auth';
  }
  return 'other';
}
